"use client";
import { getDictionary } from "@/dictionaries/dictionaries";

const AVAILABLE_LANGUAGES = ['en-US', 'es-AR', 'es-EC', 'es-MX', 'es-PE', 'es-UY', 'pt-BR'];

function resolveLangAndDictionary() {
  // Determine initial language preference
  let lang = "en-US";
  if (typeof window !== "undefined" && localStorage.getItem("lang")) {
    lang = localStorage.getItem("lang");
    if (lang === "en") {
      lang = "en-US";
    }
  } else if (typeof window !== "undefined" && navigator.language) {
    // Try exact navigator match first
    const exactDict = getDictionary(navigator.language);
    if (exactDict) {
      return { lang: navigator.language, translations: exactDict };
    }
    // Try prefix match from navigator language
    const languagePrefix = navigator.language.split("-")[0];
    const matchingLang = AVAILABLE_LANGUAGES.find((availableLang) =>
      availableLang.startsWith(languagePrefix)
    );
    if (matchingLang) {
      const dict = getDictionary(matchingLang);
      if (dict) {
        return { lang: matchingLang, translations: dict };
      }
    }
    // Fall through to global fallback below
  }

  // Global fallback or localStorage preference validation
  let translations = getDictionary(lang);
  if (!translations) {
    const languagePrefix = (lang || "").split("-")[0];
    const matchingLang = AVAILABLE_LANGUAGES.find((availableLang) =>
      availableLang.startsWith(languagePrefix)
    );
    if (matchingLang) {
      translations = getDictionary(matchingLang);
      if (translations) {
        return { lang: matchingLang, translations };
      }
    }
    // Final default
    lang = "en-US";
    translations = getDictionary(lang);
  }
  return { lang, translations };
}

export default function Trans(file, keyJson, value) {
  const { translations } = resolveLangAndDictionary();

  const getString = (dict) => {
    let valueString;
    if (keyJson.includes(".")) {
      const keysJson = keyJson.split(".");
      valueString = dict;
      keysJson.forEach((key) => {
        if (valueString !== undefined) {
          valueString = valueString[key];
        }
      });
    } else {
      valueString = dict[keyJson];
    }

    if (valueString !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((val, i) => {
          valueString = valueString.replace(`\${value${i}}`, val);
        });
      } else if (value) {
        valueString = valueString.replace(`\${value}`, value);
      }
    }

    return valueString;
  };

  const valueString = getString(translations);

  if (valueString) {
    return valueString;
  }

  return getString(file);
}
